import React, { useEffect, useState, useRef } from "react"
import "./EmailTemplateTable.scss"
import { useNavigate } from "react-router-dom"
import {
  Button,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Input,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import { Toast } from "primereact/toast"
import { OverlayPanel } from "primereact/overlaypanel"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import EmailApi from "Api/EmailApi"
import DataTableLoader from "SkeletonLoader/DataTableLoader"

const EmailTemplateDataTable = () => {
  document.title = "Email Templates"
  const navigate = useNavigate()
  const accessToken = localStorage.getItem("accessToken")
  const [emailTemplateDetails, setEmailTemplateDetails] = useState([])
  const [filteredTemplateDetails, setFilteredTemplateDetails] = useState([])
  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)
  const [filterStatus, setFilterStatus] = useState("all")
  const [loading, setLoading] = useState(true)
  const [selectedTemplates, setSelectedTemplates] = useState([])
  const op = useRef(null)
  const userData = JSON.parse(localStorage.getItem("userData"))
  const permissions = userData?.permission || []
  const [deleteModal, setDeleteModal] = useState(false)
  const [templateToDelete, setTemplateToDelete] = useState(null)
  const [otpInput, setOtpInput] = useState("")
  const [isOtpSent, setIsOtpSent] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [deletedReason, setDeletedReason] = useState("")

  const deleteToggle = () => setDeleteModal(!deleteModal)
  const toast = useRef(null)

  const breadcrumbItems = [
    { label: "Pixwik", link: "/" },
    { label: "Email", link: "/EmailTemplateTable" },
    { label: "Email Template List" },
  ]
  const handleBreadcrumbClick = link => {
    if (link !== "#") {
      navigate(link)
    }
  }

  const getAllEmailTemplates = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit: limit,
        page: page,
      },
    }

    EmailApi.getAllEmailTemplates(config)
      .then(response => {
        setLoading(false)
        setEmailTemplateDetails(response.data.data)
        setTotalRecords(response.data.totalTemplate)
      })
      .catch(error => {
        console.error("Error fetching email templates:", error)
      })
  }

  useEffect(() => {
    getAllEmailTemplates()
  }, [accessToken, page, limit])

  useEffect(() => {
    let filteredData = emailTemplateDetails

    if (filterStatus !== "all") {
      filteredData = filteredData.filter(
        data => data?.verifiedStatus?.toLowerCase() === filterStatus,
      )
    }

    setFilteredTemplateDetails(filteredData)
  }, [filterStatus, emailTemplateDetails])

  const totalPages = Math.ceil(totalRecords / limit)

  const handleAddTemplateClick = () => {
    navigate("/addEmailTemplate")
  }

  const toggleSelectAll = () => {
    if (selectedTemplates.length === filteredTemplateDetails.length) {
      setSelectedTemplates([])
    } else {
      setSelectedTemplates(filteredTemplateDetails.map(tpl => tpl._id))
    }
  }

  const toggleSelection = templateId => {
    setSelectedTemplates(prev =>
      prev.includes(templateId)
        ? prev.filter(id => id !== templateId)
        : [...prev, templateId],
    )
  }

  // const handleUpdateStatus = newStatus => {
  //   if (selectedTemplates.length === 0) {
  //     toast.current.show({
  //       severity: "warn",
  //       summary: "Warning",
  //       detail: "Please select at least one template to update.",
  //       life: 3000,
  //     })
  //     // toast.warn("Please select at least one template to update.")
  //     return
  //   }

  //   const config = {
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`,
  //     },
  //   }
  //   const payload = {
  //     emailTemplateIds: selectedTemplates,
  //     newStatus: newStatus,
  //   }

  //   EmailApi.updateEmailTemplate(payload, config)
  //     .then(response => {
  //       if (response.data.status) {
  //         toast.current.show({
  //           severity: "success",
  //           summary: "Success",
  //           detail: response.data.message,
  //           life: 3000,
  //         })
  //         // toast.success(response.data.message)
  //         getAllEmailTemplates()
  //         setSelectedTemplates([])
  //       }
  //     })
  //     .catch(error => {
  //       console.error("Error updating template status:", error)
  //       toast.current.show({
  //         severity: "error",
  //         summary: "Error",
  //         detail:
  //           error.response?.data?.message ||
  //           "Failed to update template status.",
  //         life: 3000,
  //       })
  //       // toast.error("Failed to update template status.")
  //     })
  // }

  const hasPermission = (permissions, resource, method) => {
    if (!Array.isArray(permissions.permission)) {
      console.error("Permissions is not an array:", permissions)
      return false
    }

    return permissions.permission.some(
      perm =>
        perm.permissionName === resource &&
        perm.permissionType.includes(method),
    )
  }

  const handleDeleteTemplate = id => {
    if (!id) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Invalid template ID",
        life: 3000,
      })
      return
    }

    setTemplateToDelete(id)
    setDeleteModal(true)
    // setOtpInput("")
    // setDeletedReason("")
    // setIsOtpSent(false)
  }

  // const generateOtp = () => {
  //   if (!templateToDelete) {
  //     toast.current.show({
  //       severity: "error",
  //       summary: "Error",
  //       detail: "Template ID is missing",
  //       life: 3000,
  //     });
  //     return;
  //   }

  //   const config = {
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`,
  //     },
  //   };

  //   setIsDeleting(true);

  //   EmailApi.generateDeleteTemplateOtp(templateToDelete, config)
  //     .then(response => {
  //       if (response.data.status) {
  //         setIsOtpSent(true);
  //         toast.current.show({
  //           severity: "success",
  //           summary: "Success",
  //           detail: response.data.message || "Delete confirmation email sent to admin",
  //           life: 3000,
  //         });
  //       }
  //     })
  //     .catch(error => {
  //       console.error("Error generating OTP:", error);
  //       toast.current.show({
  //         severity: "error",
  //         summary: "Error",
  //         detail: error.response?.data?.message || "Failed to send OTP",
  //         life: 3000,
  //       });
  //     })
  //     .finally(() => {
  //       setIsDeleting(false);
  //     });
  // };

  // const handleOtpChange = e => {
  //   const value = e.target.value;
  //   if (value.length <= 5) {
  //     setOtpInput(value);
  //   }
  // };

  const confirmDelete = () => {
    if (!templateToDelete) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Template ID is missing",
        life: 3000,
      })
      return
    }

    // if (!otpInput) {
    //   toast.current.show({
    //     severity: "warn",
    //     summary: "Warning",
    //     detail: "Please enter OTP",
    //     life: 3000,
    //   });
    //   return;
    // }

    // if (!deletedReason.trim()) {
    //   toast.current.show({
    //     severity: "warn",
    //     summary: "Warning",
    //     detail: "Please provide a reason for deletion",
    //     life: 3000,
    //   })
    //   return
    // }

    setIsDeleting(true)
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    // const payload = {
    //   otp: otpInput.trim(),
    //   reason: deletedReason.trim()
    // };

    EmailApi.deleteEmailTemplate(templateToDelete, config)
      .then(response => {
        if (response.data.status) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: response.data.message,
            life: 3000,
          })
          setEmailTemplateDetails(prev =>
            prev.filter(tpl => tpl._id !== templateToDelete),
          )
          handleCloseModal()
        }
      })
      .catch(error => {
        console.error("Error deleting template:", error)
        const errorMessage =
          error.response?.data?.message || "Failed to delete template"
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: errorMessage,
          life: 3000,
        })

        if (
          errorMessage.toLowerCase().includes("invalid otp") ||
          errorMessage.toLowerCase().includes("expired")
        ) {
          setOtpInput("")
        }
      })
      .finally(() => {
        setIsDeleting(false)
      })
  }

  const handleCloseModal = () => {
    setDeleteModal(false)
    setTemplateToDelete(null)
    // setOtpInput("")
    // setDeletedReason("")
    // setIsOtpSent(false)
    setIsDeleting(false)
  }

  return (
    <>
      <Toast ref={toast} position="top-right" life="3000" />
      <div className="email-template-data-table">
        {/* <ToastContainer /> */}
        <Row>
          <Col xs="12">
            <div className="template-list-header d-flex align-items-center justify-content-between">
              <CustomBreadCrumb
                data={breadcrumbItems}
                pageTitle="Email Templates"
                handleClick={handleBreadcrumbClick}
              />
              <Button
                type="button"
                color="secondary"
                className="waves-effect"
                onClick={handleAddTemplateClick}
              >
                Add Template
              </Button>
            </div>
            <div className="template-data-table table-responsive mt-4 mb-3">
              {loading ? (
                <DataTableLoader cols={10} />
              ) : (
                <Table className="table mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          onClick={toggleSelectAll}
                          checked={
                            selectedTemplates.length ===
                            filteredTemplateDetails.length
                          }
                        />
                      </th>
                      <th>#</th>
                      <th>Template Name</th>
                      <th>Subject</th>
                      {/* <th>
                        <span className="d-flex  align-items-center gap-2 justify-content-center">
                          <span>Verified Status</span>
                          <span
                            onClick={e => op.current.toggle(e)}
                            style={{ cursor: "pointer" }}
                          >
                            <i className="mdi mdi-filter" />
                          </span>
                        </span>
                        <OverlayPanel ref={op}>
                          <Input
                            type="select"
                            value={filterStatus}
                            onChange={e => {
                              setFilterStatus(e.target.value)
                              op.current.hide()
                            }}
                            style={{ width: "150px" }}
                          >
                            <option value="all">All</option>
                            <option value="approve">Approved</option>
                            <option value="reject">Rejected</option>
                            <option value="pending">Pending</option>
                          </Input>
                        </OverlayPanel>
                      </th> */}
                      <th>Edit</th>

                      <th className="text-center">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredTemplateDetails.map((data, index) => (
                      <tr key={data._id} className="template-table-row">
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedTemplates.includes(data._id)}
                            onClick={() => toggleSelection(data._id)}
                          />
                        </td>
                        <th scope="row">{(page - 1) * limit + index + 1}</th>
                        <td>{data.title}</td>
                        <td>{data.subject}</td>
                        {/* <td className="text-center">
                          <span
                            className={`status ${data?.verifiedStatus?.toLowerCase()} text-center`}
                          >
                            {data?.verifiedStatus === "approve"
                              ? "Approved"
                              : data?.verifiedStatus === "reject"
                                ? "Rejected"
                                : "Pending"}
                          </span>
                        </td> */}
                        <td className="">
                          <span
                            className="delete-template"
                            onClick={() =>
                              navigate(`/editEmailTemplate/${data._id}`, {
                                state: data,
                              })
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <i className="ion ion-md-create fs-4" />{" "}
                          </span>
                        </td>
                        <td className="text-center">
                          <span
                            className="delete-template"
                            onClick={() => handleDeleteTemplate(data._id)}
                            style={{ cursor: "pointer" }}
                          >
                            <i className="ion ion-md-trash fs-4" />{" "}
                            {/* Increased icon size */}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </div>

            <div className="pagination-container d-flex align-items-center justify-content-end">
              <Pagination>
                <PaginationItem disabled={page <= 1}>
                  <PaginationLink previous onClick={() => setPage(page - 1)} />
                </PaginationItem>
                {[...Array(Math.min(3, totalPages))].map((_, index) => (
                  <PaginationItem key={index} active={index + 1 === page}>
                    <PaginationLink onClick={() => setPage(index + 1)}>
                      {index + 1}
                    </PaginationLink>
                  </PaginationItem>
                ))}

                {totalPages > 6 && page > 3 && page < totalPages - 2 && (
                  <PaginationItem disabled>
                    <PaginationLink>...</PaginationLink>
                  </PaginationItem>
                )}

                {totalPages > 6 && page > 3 && page < totalPages - 2 && (
                  <PaginationItem active>
                    <PaginationLink onClick={() => setPage(page)}>
                      {page}
                    </PaginationLink>
                  </PaginationItem>
                )}

                {totalPages > 6 && page < totalPages - 2 && (
                  <PaginationItem disabled>
                    <PaginationLink>...</PaginationLink>
                  </PaginationItem>
                )}

                {totalPages > 3 &&
                  [...Array(Math.min(3, totalPages))].map((_, index) => {
                    const pageNumber = totalPages - 2 + index
                    return (
                      <PaginationItem
                        key={pageNumber}
                        active={pageNumber === page}
                      >
                        <PaginationLink onClick={() => setPage(pageNumber)}>
                          {pageNumber}
                        </PaginationLink>
                      </PaginationItem>
                    )
                  })}
                <PaginationItem disabled={page >= totalPages}>
                  <PaginationLink next onClick={() => setPage(page + 1)} />
                </PaginationItem>
              </Pagination>
            </div>
          </Col>
        </Row>
      </div>
      <Modal isOpen={deleteModal} toggle={handleCloseModal} centered>
        <ModalHeader toggle={handleCloseModal}>Delete Template</ModalHeader>
        <ModalBody>
          <div className="text-center">
            <i
              className="ri-delete-bin-2-line"
              style={{ fontSize: "3rem", color: "#f46a6a" }}
            />
            <h4 className="mt-3">Are you sure?</h4>
            <p className="text-muted">
              Do you really want to delete this template? This action cannot be
              undone.
            </p>
            {/* {!isOtpSent ? (
              <Button
                color="primary"
                onClick={generateOtp}
                className="mt-2"
                disabled={isDeleting}
              >
                {isDeleting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-1" />
                    Sending...
                  </>
                ) : (
                  "Generate OTP"
                )}
              </Button>
            ) : (
              <div className="mt-3">
                <p className="text-muted mb-2">
                  Please enter the OTP sent to admin email
                </p>
                <Input
                  type="text"
                  placeholder="Enter OTP"
                  value={otpInput}
                  onChange={handleOtpChange}
                  className="text-center otp-input mb-3"
                  maxLength="5"
                  autoComplete="off"
                />

                <div className="mt-3">
                  <label className="form-label text-start d-block">
                    Reason for Deletion
                  </label>
                  <Input
                    type="textarea"
                    placeholder="Please provide a reason for deletion"
                    value={deletedReason}
                    onChange={e => setDeletedReason(e.target.value)}
                    className="reason-input"
                    rows="3"
                    required
                  />
                </div>
              </div>
            )} */}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="light"
            onClick={handleCloseModal}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            color="danger"
            onClick={confirmDelete}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default EmailTemplateDataTable
